import { Inject, InjectionToken, Input, OnInit, Optional, Directive } from '@angular/core';
import { MessageTransportService } from '@nx-fe/services';

const UNKNOWN = 'No Data';
const NOT_AVAILABLE = 'n/a';

export const CELL_RENDERER_TOKEN = new InjectionToken<CellRendererData>('Cell Renderer Token');

@Directive()
export abstract class CellRendererBase<T = object | boolean | string | number> implements OnInit {
  @Input() params: CellRendererData<T>;

  @Input()
  set filter(value: string) {
    this._filter = value;
    // this.highlightValues(value);
  }

  get filter(): string {
    return this._filter;
  }

  isFullRowRenderer: boolean;

  private _textTokens: Map<string, string> = new Map<string, string>();
  private _filter = '';

  constructor(
    @Inject(CELL_RENDERER_TOKEN)
    @Optional()
    params: CellRendererData<T>,
    protected _eventTransportService: MessageTransportService
  ) {
    this.params = params;
  }

  ngOnInit(): void {
    if (this.params) {
      this.init(this.params);
    }
  }

  /**
   * Used to initialize data when used in both the grid and other areas.
   *
   * @abstract
   * @param {*} params
   *
   * @memberOf CellRenderer
   */
  abstract init(params: CellRendererData<T>): void;

  get textTokens(): Map<string, string> {
    return this._textTokens;
  }

  hasOriginalObjProperty(obj: Object, property: string): boolean {
    const topProperty = property.split('.')[0];
    return obj && obj.hasOwnProperty(topProperty);
  }

  // eslint-disable-next-line
  public getBlankValue(property: any, formatter?: (property) => string): string {
    if (property === undefined) {
      return NOT_AVAILABLE;
    } else if (!property) {
      return UNKNOWN;
    } else {
      if (formatter !== undefined && typeof formatter === 'function') {
        return formatter(property);
      }
      return property as string;
    }
  }
}

export interface CellRendererData<T = Object> {
  data: T;
  rowId: any;
  column?: {
    colId: string;
  };
  filter: string;
  /**
   * Set to true if the renderer needs to be specific for the Grid, meaning no [innerHTML]
   */
  grid?: boolean;
  params?: any;
  iconType?: string | null;
}
